// import { createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { baseUrl } from "../../../../boot";

// // Get products
// export const singUp = createAsyncThunk("client/signup-Customer", async (data, { rejectWithValue }) => {
//   console.log("data",data)
//   // const token = localStorage.getItem("authToken");

//   try {
//     const response = await axios.post(`${baseUrl}auth/api/v1/register`, data, {
//       headers: {
//         // "auth-token": token,
//         "Content-Type": "application/json",
//       },
//     });
//     console.log("Signup API Response:", response);
//     return response; // ✅ Return only the data
//   } catch (error) {
//     console.error("Error fetching products:", error);

//     // ✅ Handle errors properly
//     return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
//   }
// });


import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const singUp = createAsyncThunk(
  "client/signup-Customer",
  async (data, { rejectWithValue }) => {
    console.log("data", data);
    
    try {
      const response = await axios.post(
        `${baseUrl}auth/api/v1/register`,
        data,
        {
          withCredentials: true, // Required for cross-origin cookie authentication
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      console.log("Signup API Response:", response);
      
      // Return the complete response
      return response;
      
    } catch (error) {
      console.error("Signup error:", error);
      
      // Handle validation errors from backend
      if (error.response) {
        // Backend returned an error response
        return rejectWithValue({
          message: error.response.data?.message || "Signup failed",
          data: error.response.data || {},
          status: error.response.status
        });
      } else if (error.request) {
        // No response received
        return rejectWithValue({
          message: "No response from server. Please try again.",
          data: {}
        });
      } else {
        // Other errors
        return rejectWithValue({
          message: error.message || "Signup failed",
          data: {}
        });
      }
    }
  }
);